import { observer } from "mobx-react-lite";

import { useSchemaEditor } from "..";
import { SchemaParameterType } from "../types";

import TypeSelector from "./TypeSelector";

import { Input } from "@/components/ui/input";
import Checkbox from "@/components/ui/checkbox";

interface ParameterMetadataProps {
  name: string;
  type: SchemaParameterType;
  title: string;
  required: boolean;
  nullable: boolean;
  hideTypeControls?: boolean;
  errors?: Record<string, string>;
  onChangeName: (value: string) => void;
  onChangeType: (value: SchemaParameterType) => void;
  onChangeTitle: (value: string) => void;
  onChangeRequired: (value: boolean) => void;
  onChangeNullable: (value: boolean) => void;
}
const ParameterMetadata = observer((props: ParameterMetadataProps) => {
  const editor = useSchemaEditor();
  const { isReadonly } = editor;
  const hasNameError = props.errors && props.errors.name;

  return (
    <div className="flex w-full flex-col justify-between gap-2 sm:flex-row">
      <div className="flex flex-row items-center gap-3">
        <Checkbox
          id="required-checkbox"
          checked={props.required}
          onChange={e => props.onChangeRequired(e.target.checked)}
          label="Required"
          disabled={isReadonly}
        />
        {!props.hideTypeControls && (
          <Checkbox
            id="nullable-checkbox"
            checked={props.nullable}
            onChange={e => props.onChangeNullable(e.target.checked)}
            label="Nullable"
            disabled={isReadonly}
          />
        )}
      </div>
      <div className="flex w-full flex-col">
        <Input
          placeholder="Name"
          value={props.name}
          onChange={e => props.onChangeName(e.target.value)}
          readOnly={isReadonly}
          className={hasNameError ? "border-red-500" : ""}
        />
        {hasNameError && <span className="text-xs text-red-500">{props.errors!.name}</span>}
      </div>
      {!props.hideTypeControls && (
        <div className="flex flex-row gap-2">
          <TypeSelector value={props.type} onChange={props.onChangeType} disabled={isReadonly} />
          {props.type !== "variable" && (
            <Input
              placeholder="Title"
              value={props.title}
              className="min-w-[100px]"
              onChange={e => props.onChangeTitle(e.target.value)}
              readOnly={isReadonly}
            />
          )}
        </div>
      )}
    </div>
  );
});

export default ParameterMetadata;
